import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-enterprise';
import { IconSanitizerService, TooltipDirective } from 'ngx-lib';

export interface ICustomHeaderTooltipParams {
    title?: string;
    tooltip?: string;
}

@Component({
    selector: 'app-custom-header-tooltip',
    templateUrl: './custom-header-tooltip.component.html',
    styleUrls: ['./custom-header-tooltip.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TooltipDirective]
})
export class CustomHeaderTooltipComponent implements IHeaderAngularComp {
    params!: IHeaderParams & ICustomHeaderTooltipParams;

    title = signal<string>('');
    tooltipIcon = signal<SafeHtml | undefined>(undefined);
    tooltipText = signal<string | undefined>(undefined);

    private readonly iconSanitizer = inject(IconSanitizerService);

    agInit(params: IHeaderParams<any, any> & ICustomHeaderTooltipParams): void {
        this.params = params;
        this.title.set(this.params.title ?? this.params.displayName ?? '');
        this.tooltipIcon.set(this.iconSanitizer.getIcon('info'));
        this.tooltipText.set(this.params.tooltip);
    }

    refresh(): boolean {
        return false;
    }
}
